<template>
  <div class="app">
    <!-- 인트로 화면 (PC만) -->
    <div v-if="!isMobile" class="intro-overlay" :class="{ hide: introComplete }">
      <div class="intro-content">
        <p class="intro-line line-2" :class="{ show: showLine2, exit: exitLines }">
          오산의 새로운 기준
        </p>
        <h1 class="intro-line line-3" :class="{ show: showLine3, exit: exitLines }">
          블루밍 오산 센트럴시티 운암뜰
        </h1>
      </div>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="site-wrapper" :class="{ show: isMobile || introComplete }">
      <AppHeader />
      
      <main class="main-content" :class="{ 'mobile': isMobile }">
        <!-- 모바일 프로모션 바 (헤더 바로 아래) -->
        <MobilePromoBar v-if="isMobile" />
        <router-view :is-mobile="isMobile" />
      </main>

      <AppFooter />

      <!-- PC: 기존 플로팅 -->
      <FloatingContact v-if="!isMobile" />

      <!-- 모바일: 플로팅 버튼 + 하단 바 -->
      <template v-if="isMobile">
        <MobileFloatingContact />
        <MobileFloatingBar />
      </template>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import FloatingContact from '@/components/common/FloatingContact.vue'

// 모바일 컴포넌트
import MobilePromoBar from '@/components/mobile/MobilePromoBar.vue'
import MobileFloatingContact from '@/components/mobile/MobileFloatingContact.vue'
import MobileFloatingBar from '@/components/mobile/MobileFloatingBar.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    FloatingContact,
    MobilePromoBar,
    MobileFloatingContact,
    MobileFloatingBar
  },
  data() {
    return {
      // 디바이스 체크
      isMobile: false,
      breakpoint: 768,
      // 인트로 애니메이션
      showLine2: false,
      showLine3: false,
      exitLines: false,
      introComplete: false
    }
  },
  mounted() {
    // 디바이스 체크
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)

    // 인트로 애니메이션 (PC만)
    if (!this.isMobile) {
      this.startIntro()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice)
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= this.breakpoint
    },
    startIntro() {
      setTimeout(() => { this.showLine2 = true }, 300)
      setTimeout(() => { this.showLine3 = true }, 600)
      setTimeout(() => { this.exitLines = true }, 2100)
      setTimeout(() => { this.introComplete = true }, 2900)
    },
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/wanteddev/wanted-sans/packages/wanted-sans/fonts/webfonts/variable/split/WantedSansVariable.min.css');

:root {
  --main-color1: #c46c58;
  --main-color2: #9a5244;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Wanted Sans Variable', 'Wanted Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

.main-content {
  padding-top: 80px;
}

/* 모바일 메인 콘텐츠 */
.main-content.mobile {
  padding-top: 60px; /* 헤더 높이 (프로모바는 flow로 자연 배치) */
  padding-bottom: 70px; /* 하단 배너 공간 */
}

@media (max-width: 1024px) {
  .main-content {
    padding-top: 60px;
  }
}

/* 인트로 */
.intro-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: opacity 0.6s ease, visibility 0.6s ease;
}

.intro-overlay.hide {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.intro-content {
  text-align: center;
  overflow: hidden;
  padding: 0 20px;
}

.intro-line {
  color: #fff;
  opacity: 0;
  transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Line 1 - 오른쪽으로 빠짐 */
.line-1 {
  font-size: 25px;
  font-weight: 300;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 16px;
  transform: translateX(-30px);
}

.line-1.show {
  opacity: 1;
  transform: translateX(0);
}

.line-1.exit {
  opacity: 0;
  transform: translateX(100px);
}

/* Line 2 - 왼쪽으로 빠짐 */
.line-2 {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: 1px;
  color: var(--main-color1);
  margin-bottom: 20px;
  transform: translateX(30px);
}

.line-2.show {
  opacity: 1;
  transform: translateX(0);
}

.line-2.exit {
  opacity: 0;
  transform: translateX(-100px);
}

/* Line 3 - 오른쪽으로 빠짐 */
.line-3 {
  font-size: 42px;
  font-weight: 600;
  letter-spacing: -1px;
  transform: translateX(-30px);
}

.line-3.show {
  opacity: 1;
  transform: translateX(0);
}

.line-3.exit {
  opacity: 0;
  transform: translateX(100px);
}

/* 메인 콘텐츠 */
.site-wrapper {
  opacity: 0;
  transition: opacity 0.6s ease;
}

.site-wrapper.show {
  opacity: 1;
}

/* 반응형 */
@media (max-width: 768px) {
  .line-1 {
    font-size: 13px;
    letter-spacing: 1px;
  }

  .line-2 {
    font-size: 16px;
  }

  .line-3 {
    font-size: 24px;
  }
}
</style>